"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.savedDetailsOptions = void 0;
const buttonOptions = {
    className: 'rich-text-editor__toolbar__button'
};
exports.savedDetailsOptions = {
    options: ['inline', 'list', 'textAlign'],
    inline: {
        options: ['italic', 'underline'],
        bold: Object.assign({}, buttonOptions),
        italic: Object.assign({}, buttonOptions),
        underline: Object.assign({}, buttonOptions)
    },
    list: {
        options: ['unordered', 'ordered'],
        unordered: Object.assign({}, buttonOptions),
        ordered: Object.assign({}, buttonOptions)
    },
    textAlign: {
        inDropdown: false,
        className: undefined,
        component: undefined,
        dropdownClassName: undefined,
        options: ['left', 'center', 'right'],
        left: Object.assign({}, buttonOptions),
        center: Object.assign({}, buttonOptions),
        right: Object.assign({}, buttonOptions)
    }
};
//# sourceMappingURL=savedDetails.js.map